import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Allegato, Richiesta } from '../../types/Richiesta';
import { Stato } from '../../types/Stato';
import { catchError, Observable, throwError } from 'rxjs';
import { SicotService } from '../../sicot.service';
import { CotDisponibilita } from '../../types/CotDisponibilita';
import { BodyStampaReport, ParametroBirt } from '../../types/BodyStampaReport';
import { StatoRichResponse } from '../../types/StatoRichResponse';

class RichiestaId {
  richiestaId: string | undefined;
  cotDisponibilitaId: CotDisponibilita | undefined;
  dataAccesso: Date | undefined;
  no: boolean | undefined;
  noteAccesso: String | undefined;
  /** Id utente app_user (opzionale); usato per cot_richiesta_user quando lo stato passa a "in lavorazione". */
  appUserId?: number;
  /** Subject/identificativo WSO2 (es. da JWT); usato per cot_richiesta_user se appUserId non valorizzato. */
  wso2Sub?: string;
}

@Injectable({
  providedIn: 'root'
})

export class DettaglioRichiestaService {

  setNotificaCambioSetting(body: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<any>(
      this.sicotService.API_ENDPOINT_COT_SERVICE + '/notifica-cambio-setting',
      body, { headers }
    );
  }


  API_ENDPOINT_COT_SERVICE = this.sicotService.API_ENDPOINT_COT_SERVICE;

  constructor(private http: HttpClient, private sicotService: SicotService) {  }

  postStatoRichiesta(idRichiesta: string): Observable<StatoRichResponse> {

    let body = new RichiestaId();
    body.richiestaId = idRichiesta;
    body.cotDisponibilitaId = new CotDisponibilita();
    body.cotDisponibilitaId.id = "1";
    body.cotDisponibilitaId.data = null;

    body.cotDisponibilitaId.cotRichiestaOid = 1;
    body.cotDisponibilitaId.codice = "test";

    return this.http.post<StatoRichResponse>(`${this.API_ENDPOINT_COT_SERVICE}/flow-manager/state`, body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }),
    });

  }

  updateStatoRichiestaConDataAccesso(idRichiesta: string, dataAccesso: Date, noteAggiuntive: String): Observable<any> {

    const body = new RichiestaId();
    body.richiestaId = idRichiesta;
    body.dataAccesso = dataAccesso;
    body.noteAccesso = noteAggiuntive;
    body.wso2Sub = this.sicotService.getUserId() ?? undefined;

    return this.http
      .post<any>(this.API_ENDPOINT_COT_SERVICE + `/flow-manager/update`, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }),
      });
  }

  updateStatoRichiestaNo(idRichiesta: string): Observable<any> {

    const body = new RichiestaId();
    body.richiestaId = idRichiesta;
    body.no = true;
    body.wso2Sub = this.sicotService.getUserId() ?? undefined;

    return this.http
      .post<any>(this.API_ENDPOINT_COT_SERVICE + `/flow-manager/update`, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }),
      });
  }


  updateStatoRichiesta(idRichiesta: string): Observable<any> {

    const body = new RichiestaId();
    body.richiestaId = idRichiesta;
    body.cotDisponibilitaId = new CotDisponibilita();
    body.cotDisponibilitaId.id = "1";
    body.cotDisponibilitaId.cotRichiestaOid = 1;
    body.cotDisponibilitaId.codice = "test";
    body.wso2Sub = this.sicotService.getUserId() ?? undefined;

    return this.http
      .post<any>(this.API_ENDPOINT_COT_SERVICE + `/flow-manager/update`, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }),
      });
  }

  archiviaRichiesta(idRichiesta: string): any {

    let body = new RichiestaId();
    body.richiestaId = idRichiesta;
    body.cotDisponibilitaId = new CotDisponibilita();
    body.cotDisponibilitaId.id = "1";
    body.cotDisponibilitaId.data = null;

    body.cotDisponibilitaId.cotRichiestaOid = 1;
    body.cotDisponibilitaId.codice = "test";

    return this.http.post<any>(this.API_ENDPOINT_COT_SERVICE + `/flow-manager/archive`, body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }),
    });

  }

  downloadFile(fileId: number): Observable<Blob> {
    return this.http.get(this.API_ENDPOINT_COT_SERVICE + `/file/download/${fileId}`, { responseType: 'blob' });
  } 

  getAllegato(id: number): Observable<Allegato> {
    return this.http.get<Allegato>(this.API_ENDPOINT_COT_SERVICE + `/file/allegato/${id}`);
  }

  salvaAllegatoReportRichiesta(richiesta: Richiesta) {

    let body = new BodyStampaReport();
    body.idRichiesta = richiesta.id;
    body.parametri = [];
    body.parametri.push(new ParametroBirt('idRichiesta', richiesta?.id?.toString() || ""));
    console.log(body.parametri);

    return this.http.post<any>(this.API_ENDPOINT_COT_SERVICE + `/report-manager/report-richiesta`, body);
  }

}
